enum BankLoginSource {
  Onboarding = 'Onboarding',
  AddBankAccount = 'AddBankAccount',
  EmailMoneyTransfer = 'EmailMoneyTransfer',
  PaymentRequest = 'PaymentRequest',
}

export default BankLoginSource;
